export default __webpack_public_path__ + "static/social-1-f3c0207c5216a74cc6ebe2cd887d6297.jpg";